/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShareLinkDto } from '../../models/share-link-dto';

export interface SharingLinksShareLinkIdGet$Json$Params {
  shareLinkId: string;
}

export function sharingLinksShareLinkIdGet$Json(http: HttpClient, rootUrl: string, params: SharingLinksShareLinkIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ShareLinkDto>> {
  const rb = new RequestBuilder(rootUrl, sharingLinksShareLinkIdGet$Json.PATH, 'get');
  if (params) {
    rb.path('shareLinkId', params.shareLinkId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShareLinkDto>;
    })
  );
}

sharingLinksShareLinkIdGet$Json.PATH = '/sharing/links/{shareLinkId}';
